"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClearIndicator = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var ClearIndicator = function ClearIndicator(props) {
  return /*#__PURE__*/_react.default.createElement(_reactSelect.components.ClearIndicator, props, /*#__PURE__*/_react.default.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.99987 4.93877L9.44462 1.49477C9.58545 1.35404 9.77642 1.27502 9.97551 1.27509C10.1746 1.27516 10.3655 1.35431 10.5062 1.49514C10.647 1.63597 10.726 1.82694 10.7259 2.02603C10.7259 2.22513 10.6467 2.41604 10.5059 2.55677L7.06262 6.00002L10.5059 9.44327C10.6467 9.584 10.7259 9.77491 10.7259 9.974C10.726 10.1731 10.647 10.3641 10.5062 10.5049C10.4366 10.5746 10.3538 10.6299 10.2628 10.6677C10.1717 10.7055 10.0741 10.7249 9.97551 10.7249C9.77642 10.725 9.58545 10.646 9.44462 10.5053L5.99987 7.06127L2.55587 10.5053C2.48614 10.575 2.40336 10.6303 2.31225 10.6681C2.22114 10.7058 2.12349 10.7252 2.02487 10.7252C1.82571 10.7252 1.6347 10.6461 1.49387 10.5053C1.35304 10.3644 1.27393 10.1734 1.27393 9.97427C1.27393 9.7751 1.35304 9.5841 1.49387 9.44327L4.93787 6.00002L1.49537 2.55677C1.35454 2.41604 1.27539 2.22513 1.27532 2.02603C1.27525 1.82694 1.35427 1.63597 1.495 1.49514C1.63573 1.35431 1.82664 1.27516 2.02573 1.27509C2.22483 1.27502 2.41579 1.35404 2.55662 1.49477L5.99987 4.93877Z",
    fill: "#4F566B"
  })));
};

exports.ClearIndicator = ClearIndicator;